module.exports = "/_next/static/images/rahul2-501c696a6fd3b74838bee0003e64dd75.png";